import { useUnmount, useUpdateEffect } from 'react-use';

import { ModalTabbar } from '@/components/Modal';
import {
  selectActiveTab,
  useNomenclatureContextWindows,
  useNomenclatureStore,
  useNomenclatureStoreActions,
} from '@/components/nomenclature/useNomenclatureStore';

import type { NomenclatureModalVariant } from './types';

// ----------------------------------------------------------------------

export type NomenclatureModalTab =
  | 'general'
  | 'additionalCodesAndLinks'
  | 'images'
  | 'receptionFeatures'
  | 'expertData'
  | 'instruction'
  | 'instructionForPharmacist';

export type NomenclatureModalTabbarProps = {
  variant: NomenclatureModalVariant;
};

export const NomenclatureModalTabbar = (props: NomenclatureModalTabbarProps) => {
  const { variant } = props;
  const isCreateModal = variant === 'create';

  const { isEditModalVisible } = useNomenclatureContextWindows();
  const { setActiveTab, setPreferredTab } = useNomenclatureStoreActions();

  const activeTab = useNomenclatureStore(selectActiveTab);

  const handleChange = (newActiveTab: NomenclatureModalTab) => {
    setPreferredTab(newActiveTab);
  };

  useUpdateEffect(() => {
    if (!isEditModalVisible) {
      setActiveTab('general');
    }
  }, [isEditModalVisible]);

  useUnmount(() => {
    if (!isCreateModal) {
      setActiveTab('general');
    }
  });

  return (
    <ModalTabbar
      value={activeTab}
      tabs={[
        { label: 'Основная информация', value: 'general' },
        // { label: 'Доп. коды и ссылки', value: 'additionalCodesAndLinks' },
        // { label: 'Изображение упаковки', value: 'images' },
        // { label: 'Экспертные данные', value: 'expertData' },
        // { label: 'Инструкция', value: 'instruction' },
        // { label: 'Особенности приёма', value: 'receptionFeatures' },
        // { label: 'Инструкция для провизора', value: 'instructionForPharmacist' },
      ]}
      onChange={handleChange}
    />
  );
};
